module.exports = __webpack_public_path__ + "static/Juan Erazo Deacon-ab09226338ced06f88c2d7a03259ca34.jpg";